import { useRouter } from 'next/router';
import { useLogin, useAccount } from '@bnnvara/accounts';
import { useFingerprint } from './fingerprint';

const useAnalyticProperties = () => {
  const { isLoggedIn } = useLogin();
  const {
    profile: { UID },
  } = useAccount();
  const fingerprint = useFingerprint();
  const { asPath } = useRouter();
  return {
    url: asPath,
    loggedIn: `${isLoggedIn}`,
    fingerprint,
    userId: UID,
  };
};

export default useAnalyticProperties;
